module.exports = __webpack_public_path__ + "img/network.51fee7d4.jpeg";